import React from 'react';
import { motion } from 'framer-motion';
export function ProductPreview() {
  return <section className="py-20 md:py-28 bg-[#f8f9fa] overflow-hidden" data-id="element-187">
      <div className="max-w-5xl mx-auto px-5 sm:px-6 lg:px-8" data-id="element-188">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="text-center mb-12 md:mb-16" data-id="element-189">
          <h2 className="text-3xl md:text-4xl font-heading text-brand-slate mb-4 leading-tight" data-id="element-190">
            Mira lo que vas a recibir
          </h2>
          <p className="text-base md:text-lg text-brand-slate-light max-w-2xl mx-auto leading-relaxed" data-id="element-191">
            Un material diseñado para ser fácil de leer, práctico y directo al
            punto.
          </p>
        </motion.div>

        <div className="relative max-w-4xl mx-auto" data-id="element-192">
          <motion.div initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4
        }} className="relative z-20 bg-white rounded-2xl border border-gray-100 p-4 md:p-6" data-id="element-193">
            <div className="aspect-auto md:aspect-[16/10] bg-[#f8f9fa] rounded-xl overflow-hidden relative border border-gray-100 flex flex-col md:flex-row" data-id="element-194">
              {/* Left Page */}
              <div className="w-full md:w-1/2 h-auto md:h-full border-b md:border-b-0 md:border-r border-gray-100 p-6 md:p-10 flex flex-col justify-center bg-white" data-id="element-195">
                <div className="w-8 h-1 bg-brand-amber mb-6 rounded-full" data-id="element-196"></div>
                <h3 className="text-2xl md:text-3xl font-heading text-brand-slate mb-4 leading-tight" data-id="element-197">
                  Capítulo 3: El Miedo al Error
                </h3>
                <p className="text-brand-slate-light text-sm md:text-base leading-relaxed mb-6" data-id="element-198">
                  El error no es lo opuesto al éxito, es parte del proceso.
                  Cuando un jugador entiende esto, la presión disminuye
                  drásticamente.
                </p>
                <div className="space-y-2 mt-auto" data-id="element-199">
                  <div className="h-1.5 bg-[#f8f9fa] rounded w-full" data-id="element-200"></div>
                  <div className="h-1.5 bg-[#f8f9fa] rounded w-5/6" data-id="element-201"></div>
                  <div className="h-1.5 bg-[#f8f9fa] rounded w-4/6" data-id="element-202"></div>
                </div>
              </div>
              {/* Right Page */}
              <div className="w-full md:w-1/2 h-auto md:h-full p-6 md:p-10 bg-[#1a1a2e] text-white flex flex-col justify-center relative overflow-hidden" data-id="element-203">
                <div className="relative z-10" data-id="element-204">
                  <h4 className="text-xl md:text-2xl font-heading text-brand-amber mb-6 leading-tight" data-id="element-205">
                    Ejercicio Práctico
                  </h4>
                  <div className="bg-white/5 p-4 rounded-xl border border-white/10 mb-3" data-id="element-206">
                    <p className="text-sm md:text-base font-medium text-white/90" data-id="element-207">
                      1. Identifica el pensamiento limitante.
                    </p>
                  </div>
                  <div className="bg-white/5 p-4 rounded-xl border border-white/10 mb-3" data-id="element-208">
                    <p className="text-sm md:text-base font-medium text-white/90" data-id="element-209">
                      2. Reemplázalo por una instrucción táctica.
                    </p>
                  </div>
                  <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-210">
                    <p className="text-sm md:text-base font-medium text-white/90" data-id="element-211">
                      3. Respira y vuelve al presente.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}